import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// créer un homeWork
export const createHomework = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/homework/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier un homeWork
export const updateHomework = async (payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/homework/update/${payload.id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un devoir par son id
export const getHomeworkById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/homework/getById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un devoir par son id
export const getHomeworksAndAnswerByStudent = async (
  id_course,
  id_studentID,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/homework/getByStudent/${id_course}/${id_studentID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer un devoir avec ces réponses par un utilisateur
export const getHomeworkAndAnswerById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/homework/homeworkAndAnswer/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Supprimer un homeWork
export const deleteHomework = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/homework/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
